import { ComplexColor, Table } from "react-pptx";
import { getColorByValue } from "../../../../helpers/utils";

import { OverallActivityResult } from "../../../../types/overallActivityResult";
import { useTranslation } from "react-i18next";
import { groupedActivityTags } from "../../../../helpers/selectOptions";

type BaseLineTableCellProps = {
  backgroundColor?: string | ComplexColor | null | undefined;
  overallActivity: OverallActivityResult;
  translate: any
};

export function BaseLineTableCell({
  backgroundColor,
  overallActivity,
  translate
}: BaseLineTableCellProps): JSX.Element[] {

  return [
    <Table.Cell
      style={{
        verticalAlign: "middle",
        fontSize: 9,

        backgroundColor: backgroundColor,
      }}
    >
      {overallActivity.activityData.activityName}
    </Table.Cell>,
    <Table.Cell
      style={{
        align: "center",
        verticalAlign: "middle",
        fontSize: 11,
        backgroundColor: backgroundColor,
        color: getColorByValue(
          overallActivity.activityData.average?.mli
            ? overallActivity.activityData.average.mli
            : 0,
          "MLI",
          true
        ),
      }}
    >
      {overallActivity.activityData.average?.mli
        ? overallActivity.activityData.average.mli.toFixed(1)
        : "0"}
    </Table.Cell>,
    <Table.Cell
      style={{
        backgroundColor: backgroundColor,
        fontSize: 11,
        align: "center",
        color: getColorByValue(
          overallActivity.activityData.average?.pain
            ? overallActivity.activityData.average.pain
            : 0,
          "Pain",
          true
        ),
        verticalAlign: "middle",
      }}
    >
      {overallActivity.activityData.average?.pain
        ? overallActivity.activityData.average?.pain.toFixed(1)
        : "0"}
    </Table.Cell>,
    <Table.Cell
      style={{
        backgroundColor: backgroundColor,
        verticalAlign: "middle",
        fontSize: 9,
      }}
    >
      {overallActivity.riskFactors
        .map((riskFactor: any) => translate("tags." + riskFactor, groupedActivityTags))
        .join(", ")}
    </Table.Cell>,
  ];
}

export const BaseLineTableCellHeader = (): JSX.Element[] => {
  const precureGreen = "#5BBFAC";
  return [
    <Table.Cell
      key="task"
      style={{
        align: "center",
        verticalAlign: "middle",
        backgroundColor: precureGreen,
        color: "#FFFFFF",
        fontSize: 11,
        bold: true,
      }}
    >
      Activity
    </Table.Cell>,
    <Table.Cell
      key="risk"
      style={{
        backgroundColor: precureGreen,
        color: "#FFFFFF",
        fontSize: 11,
        bold: true,
        align: "center",
        verticalAlign: "middle",
      }}
    >
      MLI® (0-10)
    </Table.Cell>,
    <Table.Cell
      key="pain"
      style={{
        align: "center",
        verticalAlign: "middle",
        backgroundColor: precureGreen,
        color: "#FFFFFF",
        fontSize: 11,
        bold: true,
      }}
    >
      Pain (0–10)
    </Table.Cell>,
    <Table.Cell
      key="factor"
      style={{
        align: "center",
        verticalAlign: "middle",
        backgroundColor: precureGreen,
        color: "#FFFFFF",
        fontSize: 11,
        bold: true,
      }}
    >
      Highest Risk
    </Table.Cell>,
  ];
};
